import * as React from 'react';
import { Button, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { AddressParagraph } from '../address-paragraph/address-paragraph';
export const DeleteDefaultAddressModal = ({ address, hideModal, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "You Can't Delete Your Default Address"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", "data-testid": "delete-def-address-title" }, "You have to set a new default shipping address before you can delete this address."),
            React.createElement("br", null),
            React.createElement(Typography, { height: "none", weight: "bold", variant: "body-lg" }, "Current Default Address"),
            React.createElement(AddressParagraph, { address: address })),
        React.createElement(ModalFooter, { position: "center" },
            React.createElement(Button, { onClick: hideModal, variant: "primary", fullWidth: true, "data-testid": "confirm-delete-def-address-btn" }, "Got It"))));
};
DeleteDefaultAddressModal.displayName = 'DeleteDefaultAddressModal';
